import { render } from "./LatestEditWorks.vue?vue&type=template&id=5ca0c6c4"
import script from "./LatestEditWorks.vue?vue&type=script&lang=js"
export * from "./LatestEditWorks.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__